import { cx } from "@/components/ui";

/** A row of single-select option chips with reveal coloring — shared by the
 *  per-item classify drills (article / redemittel / connector). On reveal the
 *  chosen wrong chip turns red and the correct chip turns green. */
export function PickButtons({
  options,
  chosen,
  correct,
  revealed,
  onPick,
}: {
  options: string[];
  chosen: string | undefined;
  correct: string;
  revealed: boolean;
  onPick: (v: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        let tone = "border-black/10 bg-white hover:border-brand-300";
        if (revealed) {
          if (opt === correct) tone = "border-emerald-400 bg-emerald-50 text-emerald-800";
          else if (opt === chosen) tone = "border-red-400 bg-red-50 text-red-700";
          else tone = "border-black/10 bg-white opacity-60";
        } else if (opt === chosen) {
          tone = "border-brand-500 bg-brand-50 ring-1 ring-brand-300";
        }
        return (
          <button
            key={opt}
            type="button"
            disabled={revealed}
            onClick={() => onPick(opt)}
            className={cx(
              "rounded-lg border px-3 py-1.5 text-sm font-medium transition disabled:cursor-default",
              tone,
            )}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
